<div class="flyout box-flyout">
    <div class="chat-head controlbox-head">
        {[ if (!o.sticky_controlbox) { ]}
            <a class="chatbox-btn close-chatbox-button fa fa-times"></a>
        {[ } ]}
    </div>
    <div class="controlbox-panes"></div>
</div>
